export default "__VITE_ASSET__48ddaaf3__"